import { createDomVisualElement } from '../../dom/create-visual-element.mjs';
import { createMotionProxy } from '../create-proxy.mjs';
import { featureBundle } from './feature-bundle.mjs';

const motion = /*@__PURE__*/ createMotionProxy(featureBundle, createDomVisualElement);

export { motion };
